import { render, staticRenderFns } from "./poa.vue?vue&type=template&id=668bb2b9&scoped=true"
import script from "./poa.vue?vue&type=script&lang=js"
export * from "./poa.vue?vue&type=script&lang=js"
import style0 from "./poa.vue?vue&type=style&index=0&id=668bb2b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668bb2b9",
  null
  
)

export default component.exports